"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.regexp.split");

var _slicedToArray2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/slicedToArray.js"));

require("core-js/modules/es6.regexp.search");

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.find");

require("core-js/modules/es7.string.pad-start");

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _vuex = require("vuex");

var _multiUserSelect = _interopRequireDefault(require("@/views/cms/common/multiUserSelect"));

var _ossUpload = _interopRequireDefault(require("@/views/cms/common/ossUpload"));

var _cmsWorkOrder = require("@/api/cmsWorkOrder");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var _default2 = {
  name: 'ContractDesignInfo',
  components: {
    UserSelect: _multiUserSelect.default,
    OssUpload: _ossUpload.default
  },
  props: {
    contract: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapState)({
    amapApi: function amapApi(state) {
      return state.api.amapApi;
    },
    amapSecurityJsCode: function amapSecurityJsCode(state) {
      return state.api.amapSecurityJsCode;
    }
  })), {}, {
    imgPreviewPrefix: function imgPreviewPrefix() {
      return this.$store.getters.imgPreviewPrefix;
    },
    filePreviewPrefix: function filePreviewPrefix() {
      return this.$store.getters.filePreviewPrefix;
    }
  }),
  data: function data() {
    return {
      form: {
        guideUserName: '',
        guideNickName: '',
        dispatcherUserName: '',
        dispatcherNickName: '',
        designerUserName: '',
        designerNickName: '',
        contactPersonUserName: '',
        contactPersonNickName: '',
        orderClerkUserName: '',
        orderClerkNickName: '',
        contractStatusEnumeration: '',
        contractStatus: '',
        positioning: '',
        measureTime: '',
        recoveryTime: '',
        confirmPlanTime: '',
        unmeasured: '',
        planMeasureTime: '',
        measureText: '',
        signingTime: '',
        signatureDate: '',
        scheduledDeliveryDate: '',
        agreedConstructionPeriod: '',
        contactPersonFile: '',
        orderClerkFile: '',
        feedbackFile: ''
      },
      rules: {
        guide: [],
        dispatcher: [],
        contractStatusEnumeration: [],
        contractStatus: [],
        positioning: [],
        designer: [],
        contactPerson: [],
        orderClerk: [],
        measureTime: [],
        recoveryTime: [],
        confirmPlanTime: [],
        unmeasured: [],
        signingTime: [],
        signatureDate: [],
        scheduledDeliveryDate: [],
        agreedConstructionPeriod: []
      },
      guideUserList: [],
      dispatcherUserList: [],
      designerUserList: [],
      contactPersonUserList: [],
      orderClerkUserList: [],
      contactPersonFileAttachments: [],
      orderClerkFileAttachments: [],
      feedbackFileAttachments: [],
      showUserSelect: false,
      currentSelectType: '',
      measureDialogVisible: false,
      measureForm: {
        planMeasureTime: '',
        measureText: ''
      },
      mapDialogVisible: false,
      map: null,
      marker: null,
      selectedAddress: '',
      searchKeyword: '',
      searchTimer: null,
      searchResults: [],
      showSearchResults: false
    };
  },
  mounted: function mounted() {
    // 初始化表单数据
    this.initForm(); // 如果contractNo存在，调用接口加载附件数据

    if (this.form.contractNo) {
      this.loadContractFiles();
    }
  },
  watch: {
    // 监听contract变化，重新加载数据
    contract: {
      handler: function handler(newVal) {
        if (newVal) {
          this.initForm();
          this.loadContractFiles();
        }
      },
      deep: true
    }
  },
  methods: {
    // 格式化时间显示
    formatTime: function formatTime(timeStr) {
      if (!timeStr) return '';
      var date = new Date(timeStr);
      if (isNaN(date.getTime())) return timeStr;
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      var hours = String(date.getHours()).padStart(2, '0');
      var minutes = String(date.getMinutes()).padStart(2, '0');
      var seconds = String(date.getSeconds()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    },
    // 加载合同附件数据
    loadContractFiles: function loadContractFiles() {
      var _this = this;

      if (!this.form.contractNo) {
        return;
      }

      var targetId = this.contract && this.contract.id;
      (0, _cmsWorkOrder.getContract)(this.form.contractNo).then(function (contractResponse) {
        if (contractResponse.content && contractResponse.content.length > 0) {
          // 多条重复合同时，取ID与当前点击合同ID一致的那条
          var contractData;

          if (targetId) {
            contractData = contractResponse.content.find(function (item) {
              return item.id === targetId;
            });
          } // 没找到匹配的则取第一条兜底


          if (!contractData) {
            contractData = contractResponse.content[0];
          }

          if (contractData.contactPersonFile) {
            _this.form.contactPersonFile = contractData.contactPersonFile;
          }

          if (contractData.orderClerkFile) {
            _this.form.orderClerkFile = contractData.orderClerkFile;
          }

          if (contractData.feedbackFile) {
            _this.form.feedbackFile = contractData.feedbackFile;
          }

          if (contractData.planMeasureTime) {
            _this.form.planMeasureTime = contractData.planMeasureTime;
          }

          if (contractData.measureText) {
            _this.form.measureText = contractData.measureText;
          }

          _this.contactPersonFileAttachments = _this.parseFileData(_this.form.contactPersonFile);
          _this.orderClerkFileAttachments = _this.parseFileData(_this.form.orderClerkFile);
          _this.feedbackFileAttachments = _this.parseFileData(_this.form.feedbackFile);

          _this.$nextTick(function () {
            if (_this.$refs.contactPersonFileUpload) {
              _this.$refs.contactPersonFileUpload.clearFiles();

              if (_this.contactPersonFileAttachments.length > 0) {
                _this.$refs.contactPersonFileUpload.setFileList(_this.contactPersonFileAttachments);
              }
            }

            if (_this.$refs.orderClerkFileUpload) {
              _this.$refs.orderClerkFileUpload.clearFiles();

              if (_this.orderClerkFileAttachments.length > 0) {
                _this.$refs.orderClerkFileUpload.setFileList(_this.orderClerkFileAttachments);
              }
            }

            if (_this.$refs.feedbackFileUpload) {
              _this.$refs.feedbackFileUpload.clearFiles();

              if (_this.feedbackFileAttachments.length > 0) {
                _this.$refs.feedbackFileUpload.setFileList(_this.feedbackFileAttachments);
              }
            }
          });
        }
      }).catch(function (error) {
        console.error('加载合同附件数据失败:', error);
      });
    },
    initForm: function initForm() {
      var _this2 = this;

      if (this.contract) {
        //先清空页面数据
        this.form = {
          guideUserName: '',
          guideNickName: '',
          dispatcherUserName: '',
          dispatcherNickName: '',
          designerUserName: '',
          designerNickName: '',
          contactPersonUserName: '',
          contactPersonNickName: '',
          orderClerkUserName: '',
          orderClerkNickName: '',
          contractStatusEnumeration: '',
          contractStatus: '',
          positioning: '',
          measureTime: '',
          recoveryTime: '',
          confirmPlanTime: '',
          unmeasured: '',
          planMeasureTime: '',
          measureText: '',
          signingTime: '',
          signatureDate: '',
          scheduledDeliveryDate: '',
          agreedConstructionPeriod: '',
          contactPersonFile: '',
          orderClerkFile: '',
          feedbackFile: ''
        };
        this.form = _objectSpread(_objectSpread({}, this.form), this.contract); // 预计交货日期只保留日期部分

        if (this.form.scheduledDeliveryDate) {
          this.form.scheduledDeliveryDate = this.form.scheduledDeliveryDate.substring(0, 10);
        } // 初始化导购用户列表


        if (this.form.guideNickName) {
          this.guideUserList = this.form.guideNickName ? JSON.parse(this.form.guideNickName) : [];
        } else {
          this.guideUserList = [];
        } // 初始化设计中心派单员用户列表


        if (this.form.dispatcherNickName) {
          this.dispatcherUserList = this.form.dispatcherNickName ? JSON.parse(this.form.dispatcherNickName) : [];
        } else {
          this.dispatcherUserList = [];
        } // 初始化设计师用户列表


        if (this.form.designerNickName) {
          this.designerUserList = this.form.designerNickName ? JSON.parse(this.form.designerNickName) : [];
        } else {
          this.designerUserList = [];
        } // 初始化效果图组对接人用户列表


        if (this.form.contactPersonNickName) {
          this.contactPersonUserList = this.form.contactPersonNickName ? JSON.parse(this.form.contactPersonNickName) : [];
        } else {
          this.contactPersonUserList = [];
        } // 初始化下单员用户列表


        if (this.form.orderClerkNickName) {
          this.orderClerkUserList = this.form.orderClerkNickName ? JSON.parse(this.form.orderClerkNickName) : [];
        } else {
          this.orderClerkUserList = [];
        } // 初始化效果图对接人附件


        this.contactPersonFileAttachments = this.parseFileData(this.form.contactPersonFile); // 初始化下单员附件

        this.orderClerkFileAttachments = this.parseFileData(this.form.orderClerkFile); // 初始化审单反馈附件

        this.feedbackFileAttachments = this.parseFileData(this.form.feedbackFile); // 清空上传组件并回显已保存的附件

        this.$nextTick(function () {
          if (_this2.$refs.contactPersonFileUpload) {
            _this2.$refs.contactPersonFileUpload.clearFiles();

            if (_this2.contactPersonFileAttachments.length > 0) {
              _this2.$refs.contactPersonFileUpload.setFileList(_this2.contactPersonFileAttachments);
            }
          }

          if (_this2.$refs.orderClerkFileUpload) {
            _this2.$refs.orderClerkFileUpload.clearFiles();

            if (_this2.orderClerkFileAttachments.length > 0) {
              _this2.$refs.orderClerkFileUpload.setFileList(_this2.orderClerkFileAttachments);
            }
          }

          if (_this2.$refs.feedbackFileUpload) {
            _this2.$refs.feedbackFileUpload.clearFiles();

            if (_this2.feedbackFileAttachments.length > 0) {
              _this2.$refs.feedbackFileUpload.setFileList(_this2.feedbackFileAttachments);
            }
          }
        });
      }
    },
    // 解析文件数据
    parseFileData: function parseFileData(fileData) {
      var _this3 = this;

      if (!fileData) return [];

      try {
        var files = typeof fileData === 'string' ? JSON.parse(fileData) : fileData;

        if (Array.isArray(files)) {
          return files.map(function (file) {
            if (!file.type) {
              var fileName = file.realName || file.name;

              if (fileName) {
                var imgExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp'];
                var fileExtension = fileName.substring(fileName.lastIndexOf('.'));
                file.type = imgExtensions.includes(fileExtension.toLowerCase()) ? '图片' : '文件';
              } else {
                file.type = '文件';
              }
            }

            if (!file.url) {
              if (file.type === '图片') {
                file.url = _this3.imgPreviewPrefix + (file.realName || file.name);
              } else {
                file.url = _this3.filePreviewPrefix + (file.realName || file.name);
              }
            }

            return file;
          });
        }
      } catch (error) {
        console.error('解析附件数据失败:', error);
      }

      return [];
    },
    validate: function validate() {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        _this4.$refs.contractDesignInfoForm.validate(function (valid) {
          if (valid) {
            resolve(true);
          } else {
            reject(false);
          }
        });
      });
    },
    // 同步数据到父组件
    syncData: function syncData() {
      this.$emit('data-change', _objectSpread(_objectSpread({}, this.form), {}, {
        custId: this.contract.custId
      }));
    },
    // 打开用户选择
    onUserSelect: function onUserSelect(type) {
      this.currentSelectType = type;
      this.showUserSelect = true;
      this.$refs.userSelect.selectType = type;
      var typeMap = {
        '门店导购': {
          nickName: 'guideNickName',
          userName: 'guideUserName'
        },
        '设计中心派单员': {
          nickName: 'dispatcherNickName',
          userName: 'dispatcherUserName'
        },
        '设计师': {
          nickName: 'designerNickName',
          userName: 'designerUserName'
        },
        '效果图组对接人': {
          nickName: 'contactPersonNickName',
          userName: 'contactPersonUserName'
        },
        '下单员': {
          nickName: 'orderClerkNickName',
          userName: 'orderClerkUserName'
        }
      };
      var fieldMap = typeMap[type];
      var selectedUsers = [];
      var selectedUserNames = [];

      if (fieldMap) {
        var nickNameVal = this.form[fieldMap.nickName];
        var userNameVal = this.form[fieldMap.userName];
        selectedUsers = nickNameVal ? JSON.parse(nickNameVal) : [];
        selectedUserNames = userNameVal ? JSON.parse(userNameVal) : [];
      }

      this.$refs.userSelect.nickNames = selectedUsers;
      this.$refs.userSelect.userNames = selectedUserNames;
      this.$refs.userSelect.isFirst = true;
      this.$refs.userSelect.getDeptDatas(type);
    },
    // 关闭用户选择
    onUserSelectClose: function onUserSelectClose() {
      this.showUserSelect = false;
      this.currentSelectType = '';
    },
    // 选择用户回调
    selectUserCallBack: function selectUserCallBack(user) {
      var _this5 = this;

      var selectedUsers = user.nickNames;
      var selectedUserNames = user.userNames;

      if (this.currentSelectType === '门店导购') {
        this.guideUserList = selectedUsers;
        this.form.guideUserName = selectedUserNames;
        this.form.guideNickName = selectedUsers;
        this.showUserSelect = false;
      } else if (this.currentSelectType === '设计中心派单员') {
        // 弹出确认弹窗
        this.$confirm('确定要分配这些设计中心派单员吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          // 调用合同分配设计中心派单员接口
          _this5.allotDispatcher(user);
        }).catch(function () {
          // 取消操作
          _this5.showUserSelect = false;
        });
      } else if (this.currentSelectType === '设计师') {
        // 弹出确认弹窗
        this.$confirm('确定要分配这些设计师吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          // 调用合同分配设计师接口
          _this5.allotDesigners(user);
        }).catch(function () {
          // 取消操作
          _this5.showUserSelect = false;
        });
      } else if (this.currentSelectType === '效果图组对接人') {
        // 弹出确认弹窗
        this.$confirm('确定要分配这些效果图组对接人吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          // 调用合同分配效果图组对接人接口
          _this5.allotContactPerson(user);
        }).catch(function () {
          // 取消操作
          _this5.showUserSelect = false;
        });
      } else if (this.currentSelectType === '下单员') {
        this.$confirm('确定要分配这些下单员吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          _this5.allotOrderClerk(user);
        }).catch(function () {
          _this5.showUserSelect = false;
        });
      }
    },
    // 分配设计中心派单员
    allotDispatcher: function allotDispatcher(user) {
      var _this6 = this;

      // 构建请求参数
      var params = {
        type: '设计中心派单员',
        custId: this.form.custId,
        userNames: user.userNames,
        nickNames: user.nickNames,
        contractId: this.form.id
      }; // 调用接口

      (0, _cmsWorkOrder.allotSelectUsers)(params).then(function (response) {
        if (response.code === 200) {
          _this6.$message.success('设计中心派单员分配成功'); // 更新本地数据


          _this6.dispatcherUserList = user.nickNames;
          _this6.form.dispatcherUserName = user.userNames;
          _this6.form.dispatcherNickName = user.nickNames; // 触发事件通知父组件重新查询客户数据

          _this6.syncData();

          _this6.showUserSelect = false;
        } else {
          _this6.$message.error(response.msg || '设计中心派单员分配失败');

          _this6.showUserSelect = false;
        }
      }).catch(function (error) {
        console.error('分配设计中心派单员失败:', error);

        _this6.$message.error('网络错误，请重试');

        _this6.showUserSelect = false;
      });
    },
    // 分配下单员
    allotOrderClerk: function allotOrderClerk(user) {
      var _this7 = this;

      var params = {
        type: '下单员',
        custId: this.form.custId,
        userNames: user.userNames,
        nickNames: user.nickNames,
        contractId: this.form.id
      };
      (0, _cmsWorkOrder.allotSelectUsers)(params).then(function (response) {
        if (response.code === 200) {
          _this7.$message.success('下单员分配成功');

          _this7.orderClerkUserList = user.nickNames;
          _this7.form.orderClerkUserName = user.userNames;
          _this7.form.orderClerkNickName = user.nickNames;

          _this7.syncData();

          _this7.showUserSelect = false;
        } else {
          _this7.$message.error(response.msg || '下单员分配失败');

          _this7.showUserSelect = false;
        }
      }).catch(function (error) {
        console.error('分配下单员失败:', error);

        _this7.$message.error('网络错误，请重试');

        _this7.showUserSelect = false;
      });
    },
    // 分配效果图组对接人
    allotContactPerson: function allotContactPerson(user) {
      var _this8 = this;

      // 构建请求参数
      var params = {
        type: '效果对接人',
        custId: this.form.custId,
        userNames: user.userNames,
        nickNames: user.nickNames,
        contractId: this.form.id
      }; // 调用接口

      (0, _cmsWorkOrder.allotSelectUsers)(params).then(function (response) {
        if (response.code === 200) {
          _this8.$message.success('效果图组对接人分配成功'); // 更新本地数据


          _this8.contactPersonUserList = user.nickNames;
          _this8.form.contactPersonUserName = user.userNames;
          _this8.form.contactPersonNickName = user.nickNames; // 触发事件通知父组件重新查询客户数据

          _this8.syncData();

          _this8.showUserSelect = false;
        } else {
          _this8.$message.error(response.msg || '效果图组对接人分配失败');

          _this8.showUserSelect = false;
        }
      }).catch(function (error) {
        console.error('分配效果图组对接人失败:', error);

        _this8.$message.error('网络错误，请重试');

        _this8.showUserSelect = false;
      });
    },
    // 分配设计师
    allotDesigners: function allotDesigners(user) {
      var _this9 = this;

      // 构建请求参数
      var params = {
        type: '设计师',
        custId: this.form.custId,
        userNames: user.userNames,
        nickNames: user.nickNames,
        contractId: this.form.id
      }; // 调用接口

      (0, _cmsWorkOrder.allotSelectUsers)(params).then(function (response) {
        if (response.code === 200) {
          _this9.$message.success('设计师分配成功'); // 更新本地数据


          _this9.designerUserList = user.nickNames;
          _this9.form.designerUserName = user.userNames;
          _this9.form.designerNickName = user.nickNames; // 触发事件通知父组件重新查询客户数据

          _this9.syncData();

          _this9.showUserSelect = false;
        } else {
          _this9.$message.error(response.msg || '设计师分配失败');

          _this9.showUserSelect = false;
        }
      }).catch(function (error) {
        console.error('分配设计师失败:', error);

        _this9.$message.error('网络错误，请重试');

        _this9.showUserSelect = false;
      });
    },
    // 打开派测量弹窗
    openMeasureDialog: function openMeasureDialog() {
      if (!this.form.id) {
        this.$message.error('合同ID不能为空');
        return;
      }

      this.measureForm = {
        planMeasureTime: this.form.planMeasureTime || '',
        measureText: this.form.measureText || ''
      };
      this.measureDialogVisible = true;
    },
    // 提交派测量
    submitMeasure: function submitMeasure() {
      var _this10 = this;

      if (!this.measureForm.planMeasureTime) {
        this.$message.error('请选择计划测量时间');
        return;
      }

      if (!this.measureForm.measureText) {
        this.$message.error('请输入派测量要求');
        return;
      }

      var params = {
        id: this.form.id,
        planMeasureTime: this.measureForm.planMeasureTime,
        measureText: this.measureForm.measureText
      };
      (0, _cmsWorkOrder.measure)(params).then(function (response) {
        if (response.code === 200) {
          _this10.$message.success('派测量成功');

          _this10.measureDialogVisible = false; // 回填表单，用于旁边回显

          _this10.form.planMeasureTime = _this10.measureForm.planMeasureTime;
          _this10.form.measureText = _this10.measureForm.measureText;

          _this10.syncData();
        } else {
          _this10.$message.error(response.msg || '派测量失败');
        }
      }).catch(function (error) {
        console.error('派测量失败:', error);

        _this10.$message.error('网络错误，请重试');
      });
    },
    // 处理测量时间按钮点击
    handleMeasured: function handleMeasured() {
      var _this11 = this;

      if (!this.form.id) {
        this.$message.error('合同ID不能为空');
        return;
      } // 弹出确认对话框


      this.$confirm('确定要标记为已测量吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 构建请求参数
        var params = {
          id: _this11.form.id
        }; // 调用接口

        (0, _cmsWorkOrder.measured)(params).then(function (response) {
          if (response.code === 200) {
            _this11.$message.success('标记已测量成功'); // 更新本地数据


            _this11.form.measureTime = new Date().toISOString(); // 触发事件通知父组件重新查询客户数据

            _this11.syncData();
          } else {
            _this11.$message.error(response.msg || '标记已测量失败');
          }
        }).catch(function (error) {
          console.error('标记已测量失败:', error);

          _this11.$message.error('网络错误，请重试');
        });
      }).catch(function () {// 取消操作
      });
    },
    // 处理复尺时间按钮点击
    handleSizeVerified: function handleSizeVerified() {
      var _this12 = this;

      if (!this.form.id) {
        this.$message.error('合同ID不能为空');
        return;
      } // 弹出确认对话框


      this.$confirm('确定要标记为已复尺吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 构建请求参数
        var params = {
          id: _this12.form.id
        }; // 调用接口

        (0, _cmsWorkOrder.sizeVerified)(params).then(function (response) {
          if (response.code === 200) {
            _this12.$message.success('标记已复尺成功'); // 更新本地数据


            _this12.form.recoveryTime = new Date().toISOString(); // 触发事件通知父组件重新查询客户数据

            _this12.syncData();
          } else {
            _this12.$message.error(response.msg || '标记已复尺失败');
          }
        }).catch(function (error) {
          console.error('标记已复尺失败:', error);

          _this12.$message.error('网络错误，请重试');
        });
      }).catch(function () {// 取消操作
      });
    },
    // 处理确认方案时间按钮点击
    handleConfirmPlan: function handleConfirmPlan() {
      var _this13 = this;

      if (!this.form.contractNo) {
        this.$message.error('合同号不能为空');
        return;
      } // 弹出确认对话框


      this.$confirm('确定要标记为已确认方案吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 构建请求参数
        var params = {
          id: _this13.form.id
        }; // 调用接口

        (0, _cmsWorkOrder.confirmPlan)(params).then(function (response) {
          if (response.code === 200) {
            _this13.$message.success('标记已确认方案成功'); // 重新加载合同数据


            (0, _cmsWorkOrder.getContract)(_this13.form.contractNo).then(function (contractResponse) {
              if (contractResponse.content.length > 0) {
                var contractData = contractResponse.content[0]; // 加载新数据到表单

                _this13.form = _objectSpread(_objectSpread({}, _this13.form), contractData); // 触发事件通知父组件更新合同数据

                _this13.syncData();
              }
            });
          } else {
            _this13.$message.error(response.msg || '标记已确认方案失败');
          }
        }).catch(function (error) {
          console.error('标记已确认方案失败:', error);

          _this13.$message.error('网络错误，请重试');
        });
      }).catch(function () {// 取消操作
      });
    },
    // 打开地图选择器
    openMapSelector: function openMapSelector() {
      var _this14 = this;

      this.mapDialogVisible = true;
      this.$nextTick(function () {
        _this14.initMap(); // 如果位置不为空，加载位置


        if (_this14.form.positioning) {
          // 解析位置信息
          var position = _this14.form.positioning; // 提取经纬度信息

          var lnglatMatch = position.match(/\((\d+\.\d+),\s*(\d+\.\d+)\)/);

          if (lnglatMatch) {
            var lng = parseFloat(lnglatMatch[1]);
            var lat = parseFloat(lnglatMatch[2]); // 在地图上标记位置

            _this14.map && _this14.map.setCenter([lng, lat]);
          }
        }
      });
    },
    // 初始化地图
    initMap: function initMap() {
      var _this15 = this;

      // 先设置安全密钥（必须在加载JSAPI之前执行）
      window._AMapSecurityConfig = {
        securityJsCode: this.amapSecurityJsCode // 从Vuex store中获取安全密钥

      }; // 引入高德地图API

      if (typeof window.AMap === 'undefined') {
        var script = document.createElement('script');
        script.type = 'text/javascript'; // 使用从Vuex store中获取的配置

        script.src = this.amapApi + '&callback=initAmap';
        script.async = true;
        script.defer = true;
        document.head.appendChild(script); // 定义全局回调函数

        window.initAmap = function () {
          _this15.createMap();
        };
      } else {
        this.createMap();
      }
    },
    // 创建地图
    createMap: function createMap() {
      var _this16 = this;

      try {
        // 初始化地图
        var center = [108.370859, 22.678838]; // 默认爱阁工房智慧工厂
        // 如果位置信息不为空，使用位置信息作为默认位置

        if (this.form.positioning) {
          var lnglatMatch = this.form.positioning.match(/\((\d+\.\d+),\s*(\d+\.\d+)\)/);

          if (lnglatMatch) {
            var lng = parseFloat(lnglatMatch[1]);
            var lat = parseFloat(lnglatMatch[2]);
            center = [lng, lat];
          }
        }

        this.map = new window.AMap.Map('mapContainer', {
          center: center,
          zoom: 19,
          resizeEnable: true,
          pitch: 0,
          rotation: 0
        }); // 添加地图控件

        window.AMap.plugin(['AMap.Scale', 'AMap.ToolBar'], function () {
          _this16.map.addControl(new window.AMap.Scale());

          _this16.map.addControl(new window.AMap.ToolBar());
        }); // 添加默认位置图标

        this.marker = new window.AMap.Marker({
          position: center,
          icon: new window.AMap.Icon({
            size: new window.AMap.Size(20, 34),
            image: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png',
            imageSize: new window.AMap.Size(20, 34)
          })
        }); // 添加标记到地图

        this.map.add(this.marker); // 启用地图交互功能
        // 高德地图默认已启用基本交互功能
        // 添加点击事件，获取点击位置的地址

        this.map.on('click', function (e) {
          var lnglat = e.lnglat; // 清除之前的标记

          if (_this16.marker) {
            _this16.map.remove(_this16.marker);
          } // 添加新标记


          _this16.marker = new window.AMap.Marker({
            position: lnglat,
            icon: new window.AMap.Icon({
              size: new window.AMap.Size(20, 34),
              image: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png',
              imageSize: new window.AMap.Size(20, 34)
            })
          });

          _this16.map.add(_this16.marker); // 通过逆地理编码获取地址


          window.AMap.plugin('AMap.Geocoder', function () {
            var geocoder = new window.AMap.Geocoder({
              radius: 100,
              extensions: 'all'
            });
            geocoder.getAddress(lnglat, function (status, result) {
              if (status === 'complete' && result.regeocode) {
                _this16.selectedAddress = "".concat(result.regeocode.formattedAddress, " (").concat(lnglat.getLng().toFixed(6), ", ").concat(lnglat.getLat().toFixed(6), ")");
              } else {
                _this16.selectedAddress = "".concat(lnglat.getLng().toFixed(6), ", ").concat(lnglat.getLat().toFixed(6));
              }
            });
          });
        }); // 默认搜索并定位到爱阁工房
        // this.searchKeyword = '爱阁工房智慧工厂'
        // this.searchLocation()
      } catch (error) {
        this.$message.error('地图初始化失败，请重试');
      }
    },
    // 确认选择位置
    confirmMapSelection: function confirmMapSelection() {
      if (this.selectedAddress) {
        var lnglatMatch = this.selectedAddress.match(/\((\d+\.\d+),\s*(\d+\.\d+)\)/);

        if (lnglatMatch) {
          this.form.positioning = "".concat(lnglatMatch[1], ", ").concat(lnglatMatch[2]);
        }
      } else if (this.map) {
        var center = this.map.getCenter();
        this.form.positioning = "".concat(center.getLng(), ", ").concat(center.getLat());
      }

      this.mapDialogVisible = false;
    },
    // 搜索位置
    searchLocation: function searchLocation() {
      var _this17 = this;

      if (!this.searchKeyword) {
        this.$message.warning('请输入搜索关键词');
        return;
      }

      if (this.map && window.AMap) {
        try {
          // 使用高德地图的搜索服务
          window.AMap.plugin('AMap.PlaceSearch', function () {
            // 高德 PlaceSearch 搜索（修复版，无限制，全地图检索）
            var placeSearch = new window.AMap.PlaceSearch({
              pageSize: 20,
              // 显示20条结果
              pageIndex: 1,
              city: "全国",
              // ✅ 关键：取消城市限制，搜全国
              type: "",
              // ✅ 关键：不限制POI分类（工厂、公司、门店都能搜到）
              radius: 50000,
              // ✅ 半径50公里（足够大）
              citylimit: false // ✅ 关键：false = 不强制限制在某个城市

            });

            try {
              placeSearch.search(_this17.searchKeyword, function (status, result) {
                if (status === 'complete') {
                  // 检查result.poiList.pois或result.pois
                  var pois = [];

                  if (result && result.poiList && result.poiList.pois) {
                    pois = result.poiList.pois;
                  } else if (result && result.pois) {
                    pois = result.pois;
                  }

                  if (pois && pois.length > 0) {
                    // 存储搜索结果
                    _this17.searchResults = pois; // 显示搜索结果列表

                    _this17.showSearchResults = true; // 如果只有一个结果，直接选择

                    if (pois.length === 1) {
                      var poi = pois[0];

                      _this17.selectSearchResult(poi);
                    }
                  } else {
                    _this17.$message.info('未找到匹配的位置');

                    _this17.searchResults = [];
                    _this17.showSearchResults = false;
                  }
                } else {
                  _this17.$message.info('未找到匹配的位置');

                  _this17.searchResults = [];
                  _this17.showSearchResults = false;
                }
              });
            } catch (error) {
              _this17.$message.error('搜索失败，请重试');

              _this17.searchResults = [];
              _this17.showSearchResults = false;
            }
          });
        } catch (error) {
          this.$message.error('搜索失败，请重试');
          this.searchResults = [];
          this.showSearchResults = false;
        }
      } else {
        this.$message.error('地图未初始化，请重试');
        this.searchResults = [];
        this.showSearchResults = false;
      }
    },
    // 选择搜索结果
    selectSearchResult: function selectSearchResult(result) {
      // 隐藏搜索结果列表
      this.showSearchResults = false; // 解析坐标

      var lnglat;

      if (result.location) {
        if (typeof result.location === 'string') {
          // 如果location是字符串，解析为经纬度数组
          var _result$location$spli = result.location.split(',').map(Number),
              _result$location$spli2 = (0, _slicedToArray2.default)(_result$location$spli, 2),
              lng = _result$location$spli2[0],
              lat = _result$location$spli2[1];

          lnglat = new window.AMap.LngLat(lng, lat);
        } else if (Array.isArray(result.location)) {
          // 如果location是数组，直接使用
          var _result$location = (0, _slicedToArray2.default)(result.location, 2),
              _lng = _result$location[0],
              _lat = _result$location[1];

          lnglat = new window.AMap.LngLat(_lng, _lat);
        } else {
          // 如果location是对象，直接使用
          lnglat = result.location;
        }
      }

      if (lnglat) {
        // 清除之前的标记
        if (this.marker) {
          this.map.remove(this.marker);
        } // 添加新标记


        this.marker = new window.AMap.Marker({
          position: lnglat
        });
        this.map.add(this.marker); // 设置地图中心点

        this.map.setCenter(lnglat);
        this.map.setZoom(15); // 设置选中地址
        // 对于PlaceSearch结果，使用name和address组合

        if (result.name && result.address) {
          this.selectedAddress = "".concat(result.name, " ").concat(result.address);
        } else if (result.name) {
          this.selectedAddress = result.name;
        } else if (result.address) {
          this.selectedAddress = result.address;
        } else if (result.formattedAddress) {
          // 兼容Geocoder结果
          this.selectedAddress = result.formattedAddress;
        } else {
          this.selectedAddress = "".concat(lnglat.getLng(), ", ").concat(lnglat.getLat());
        }
      } else {
        this.$message.info('未找到匹配的位置');
      }
    },
    // 处理搜索输入
    handleSearchInput: function handleSearchInput() {
      var _this18 = this;

      // 清除之前的定时器
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      } // 设置新的定时器，实现防抖


      this.searchTimer = setTimeout(function () {
        if (_this18.searchKeyword && _this18.searchKeyword.length >= 2) {
          _this18.searchLocation();
        } else if (_this18.searchKeyword.length < 2) {
          // 输入字符少于2个，隐藏搜索结果列表
          _this18.searchResults = [];
          _this18.showSearchResults = false;
        }
      }, 100); // 减少防抖时间，提高实时性
    },
    // 下载文件
    downloadFile: function downloadFile(url) {
      if (!url) return;
      fetch(url, {
        mode: 'cors'
      }).then(function (res) {
        return res.blob();
      }).then(function (blob) {
        var blobUrl = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = blobUrl;
        a.download = url.substring(url.lastIndexOf('/') + 1) || 'download';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);
      }).catch(function () {
        window.open(url, '_blank');
      });
    },
    // 处理效果图对接人附件上传成功
    handleContactPersonFileUpload: function handleContactPersonFileUpload(fileInfo, allFiles) {
      var files = this.$refs.contactPersonFileUpload ? this.$refs.contactPersonFileUpload.getUploadedFiles() : [];
      this.form.contactPersonFile = files.length > 0 ? JSON.stringify(files) : '';
      this.contactPersonFileAttachments = this.parseFileData(this.form.contactPersonFile);
      if (fileInfo) this.$message.success('效果图对接人附件上传成功');
    },
    // 处理效果图对接人附件删除成功
    handleContactPersonFileDelete: function handleContactPersonFileDelete(file, remainFiles) {
      var files = this.$refs.contactPersonFileUpload ? this.$refs.contactPersonFileUpload.getUploadedFiles() : [];
      this.form.contactPersonFile = files.length > 0 ? JSON.stringify(files) : '';
      this.contactPersonFileAttachments = this.parseFileData(this.form.contactPersonFile);
    },
    // 删除效果图对接人附件（通过索引）
    delContactPersonFileByIndex: function delContactPersonFileByIndex(index) {
      if (this.contactPersonFileAttachments && this.contactPersonFileAttachments.length > index) {
        this.contactPersonFileAttachments.splice(index, 1);

        if (this.contactPersonFileAttachments.length > 0) {
          this.form.contactPersonFile = JSON.stringify(this.contactPersonFileAttachments);
        } else {
          this.form.contactPersonFile = '';
        }
      }
    },
    // 处理下单员附件上传成功
    handleOrderClerkFileUpload: function handleOrderClerkFileUpload(fileInfo, allFiles) {
      var files = this.$refs.orderClerkFileUpload ? this.$refs.orderClerkFileUpload.getUploadedFiles() : [];
      this.form.orderClerkFile = files.length > 0 ? JSON.stringify(files) : '';
      this.orderClerkFileAttachments = this.parseFileData(this.form.orderClerkFile);
      if (fileInfo) this.$message.success('下单员附件上传成功');
    },
    // 处理下单员附件删除成功
    handleOrderClerkFileDelete: function handleOrderClerkFileDelete(file, remainFiles) {
      var files = this.$refs.orderClerkFileUpload ? this.$refs.orderClerkFileUpload.getUploadedFiles() : [];
      this.form.orderClerkFile = files.length > 0 ? JSON.stringify(files) : '';
      this.orderClerkFileAttachments = this.parseFileData(this.form.orderClerkFile);
    },
    // 删除下单员附件（通过索引）
    delOrderClerkFileByIndex: function delOrderClerkFileByIndex(index) {
      if (this.orderClerkFileAttachments && this.orderClerkFileAttachments.length > index) {
        this.orderClerkFileAttachments.splice(index, 1);

        if (this.orderClerkFileAttachments.length > 0) {
          this.form.orderClerkFile = JSON.stringify(this.orderClerkFileAttachments);
        } else {
          this.form.orderClerkFile = '';
        }
      }
    },
    handleFeedbackFileUpload: function handleFeedbackFileUpload(fileInfo, allFiles) {
      var files = this.$refs.feedbackFileUpload ? this.$refs.feedbackFileUpload.getUploadedFiles() : [];
      this.form.feedbackFile = files.length > 0 ? JSON.stringify(files) : '';
      this.feedbackFileAttachments = this.parseFileData(this.form.feedbackFile);
      if (fileInfo) this.$message.success('审单反馈附件上传成功');
    },
    handleFeedbackFileDelete: function handleFeedbackFileDelete(file, remainFiles) {
      var files = this.$refs.feedbackFileUpload ? this.$refs.feedbackFileUpload.getUploadedFiles() : [];
      this.form.feedbackFile = files.length > 0 ? JSON.stringify(files) : '';
      this.feedbackFileAttachments = this.parseFileData(this.form.feedbackFile);
    },
    delFeedbackFileByIndex: function delFeedbackFileByIndex(index) {
      if (this.feedbackFileAttachments && this.feedbackFileAttachments.length > index) {
        this.feedbackFileAttachments.splice(index, 1);

        if (this.feedbackFileAttachments.length > 0) {
          this.form.feedbackFile = JSON.stringify(this.feedbackFileAttachments);
        } else {
          this.form.feedbackFile = '';
        }
      }
    },
    // 保存设计信息
    saveDesignInfo: function saveDesignInfo() {
      var _this19 = this;

      this.$refs.contractDesignInfoForm.validate(function (valid) {
        if (valid) {
          var contractNo = _this19.contract.contractNo || _this19.form.contractNo || '';
          _this19.form.contactPersonFile = _this19.addAliasToFiles(_this19.form.contactPersonFile, contractNo);
          _this19.form.orderClerkFile = _this19.addAliasToFiles(_this19.form.orderClerkFile, contractNo);
          _this19.form.feedbackFile = _this19.addAliasToFiles(_this19.form.feedbackFile, contractNo);

          var saveData = _objectSpread(_objectSpread({}, _this19.contract), _this19.form);

          (0, _cmsWorkOrder.editContract)(saveData).then(function (response) {
            if (response.code === 200) {
              _this19.$message.success('保存成功');

              _this19.syncData();
            } else {
              _this19.$message.error(response.msg || '保存失败');
            }
          }).catch(function (error) {
            _this19.$message.error('保存失败，请重试');
          });
        } else {
          _this19.$message.error('请检查表单数据');
        }
      });
    },
    addAliasToFiles: function addAliasToFiles(fileData, contractNo) {
      if (!fileData || !contractNo) return fileData || '';

      try {
        var files = typeof fileData === 'string' ? JSON.parse(fileData) : fileData;

        if (Array.isArray(files)) {
          var result = files.map(function (file, index) {
            return _objectSpread(_objectSpread({}, file), {}, {
              alias: file.alias || contractNo + '_' + (index + 1) + '_' + (file.localName || file.realName)
            });
          });
          return JSON.stringify(result);
        }
      } catch (e) {
        console.error('生成别名失败:', e);
      }

      return fileData;
    }
  }
};
exports.default = _default2;